export {default} from './LanguageSelector'
export * from './LanguageSelectorProps'
export const LANG_KEY = 'language';
export const getLanguage = () => localStorage.getItem(LANG_KEY);
